import { createStyles, Theme } from "@material-ui/core/styles";

export default (theme: Theme) =>
    createStyles({
        root: {
            height: "100%",
            width: "30%",
        },
    });
